import { UserToken } from "@app/store/useUserVarStore";
import { RECOMMENDED_COUNT_PER_PAGE } from "@config/quickNews";
import fetchBHApi from "@helper/fetchBHApi";
import logger from "@src/logger/Logger";
import { ProcessedArticleData } from "@transformer/useOSResponse";

type RecommendationResponse = {
  data: { path: string }[];
};

type MoreArticleFeedsResponse = {
  articlePaths: string[];
};

type GetArticlesByIdsApiResponse = {
  data?: ProcessedArticleData[];
};

export async function getMoreChartBeatRecommendedArticleFeeds(
  userToken: UserToken,
  deviceId: string | null,
  page?: number,
  size?: number,
  sections?: string[],
): Promise<MoreArticleFeedsResponse> {
  const userType = userToken.type == "device_id" ? "deviceid" : userToken.type;
  const requestDataWithPagination = {
    contentType: "article",
    userType: userType || "deviceId",
    userId: userToken.id || deviceId,
    page: page ?? 1,
    size: size ?? RECOMMENDED_COUNT_PER_PAGE,
    sections: sections ?? [],
    getPayload: true,
  };

  try {
    const recommendations = await fetchBHApi<RecommendationResponse>(
      `chartbeat/recommendations`,
      "POST",
      requestDataWithPagination,
    );
    const articlePaths = recommendations.data.map(({ path }) =>
      path.replace("beritaharian.sg", "").replace(/\?cb_rec=[^&]+/, ""),
    );
    return { articlePaths };
  } catch {
    logger.error("Failed to fetch recommended article paths for myBH", {
      requestData: requestDataWithPagination,
    });
    return {
      articlePaths: [],
    };
  }
}

export async function fetchArticlesByPaths(
  articlePaths: string[],
): Promise<ProcessedArticleData[]> {
  try {
    const response = await fetchBHApi<GetArticlesByIdsApiResponse>(
      `get-articles-by-paths`,
      "POST",
      { articlePaths },
    );
    return response.data || [];
  } catch (error) {
    logger.error(
      "Failed to fetch articles by paths for chart beat recommendations",
      {
        error: (error as Error).message,
        articlePaths,
      },
    );
    return [] as ProcessedArticleData[];
  }
}
